<article class="">
    <header class="">
        <div class="">
            <ul class="list-inline d-flex justify-content-between mb-0">
                <li class="list-inline-item">
                    <h1 class="">Contract Validity</h1>
                </li>
                <li class="list-inline-item">
                    <button class="btn btn-icon btn-light-info mx-1" (click)="printPage()">
                        <i class="ti ti-printer"></i>
                    </button>
                    <button aria-label="Copy link" class="btn btn-icon btn-light-info" (click)="copyFullPageText()">
                        <i class="ti ti-copy"></i>
                    </button>
                </li>
            </ul>
        </div>
    </header>
    <div class="">
        <div class="card-body p-2">
            <p class="mt-1">This article provides a brief introduction into how Xeneta views contracted rates depending
                on the length
                of their associated contracts, and how these rates can be filtered in the platform based on their
                validity using the <span class="text-primary cursor-pointer"
                    (click)="goToContractedWithin('Contracted Within')">Contracted Within</span> filter.</p>
            <h2>Validity and Average Rate</h2>
            <p>The way Xeneta handles rates associated with long-term contracts of different length can be presented as
                a graph where length of each line indicates the duration of a contracted rate, while its vertical
                position indicates the negotiated amount in USD.</p>
            <p><img src="https://cdn.elev.io/file/uploads/7rMuoX7QtXJ6psY2MyB2fXmaIgxnxoeXBP57N-qzYow/JJKZcX0RnsnGHvtSle_vExY3c3KmdKhDxp6pZiEdHVQ/futures-01-QzE.png"
                    class="fr-fic fr-dib"></p>
            <p>Xeneta creates a <span aria-label="Market Benchmarks" class="text-primary cursor-pointer"
                    (click)="goToContractedWithin('Market Benchmarks')">benchmark value</span> by calculating an average
                figure for all
                valid rates for a single day. So in the example above, the arithmetic average of the 5 rates on the
                graph that pass through the blue dashed line will be $300.</p>
            <p>This is the most basic scenario of how Xeneta presents rates from across the market as a single value
                that is used for benchmarking.</p>
            <h2>Validity and Contracted Within</h2>
            <p>By default, Xeneta combines all contracted rates that are valid on a given day into a single average
                rate.</p>
            <p>This includes contracts that were negotiated in the past, as well as those that have started recently.
                This means that long-term contracts from several months ago will influence the benchmark rate provided
                by Xeneta.</p>
            <p>If you're primarily interested in the most current freight rates available on the market, you can choose
                to exclude older contracts by using the <span class="text-primary cursor-pointer"
                    (click)="goToContractedWithin('Contracted Within')">Contracted Within</span> option when selecting
                the <strong>Contract
                    Length</strong>&nbsp; <span aria-label="Market Metrics" class="text-primary cursor-pointer"
                    (click)="goToContractedWithin('Market Metrics')">metric</span>.</p>
            <p>This allows you to only see the rates that have been contracted recently.</p>
            <p><img src="https://cdn.elev.io/file/uploads/7rMuoX7QtXJ6psY2MyB2fXmaIgxnxoeXBP57N-qzYow/zJSGIPyi7ZR8DIbXrQ2ymsVm5det1ybVzfCKWO8jxYk/futures-02-4eA.png"
                    class="fr-fic fr-dib"></p>
            <p>In this example, if we calculate the market average only for those contracts that start within the scope
                of the <strong>Contracted Within Last 3 Months</strong> option (within the area highlighted in pink),
                we'll find that the average market rate is $350.</p>
            <p>In this specific case, looking only at newer contracts allows us to conclude that the market is moving
                towards a higher average rate.</p>
            <blockquote class="my-4 p-3 bg-yellow-100 color-block">Xeneta can also look at contracts that are valid
                beyond the current day
                or are contracted to start at some point in the future. To learn more about how to use this feature, see
                our <span class="text-primary cursor-pointer" (click)="goToContractedWithin('Future Rates')">Future
                    Rates</span> article.</blockquote>
        </div>
    </div>
</article>